import React, { useEffect, useState } from "react";
import { List } from "antd";
import axios from "axios";
import moment from "moment";
import { API_URL } from "../../constants";
import { FileDoneOutlined } from "@ant-design/icons";

const FileList = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    async function getData() {
      try {
        const res = await axios.get(API_URL + "user/lastDoc");
        console.log(res);
        setData(res.data);
      } catch (error) {
        console.log(error);
      }
    }
    getData();
  }, []);

  return (
    <List
      itemLayout="horizontal"
      dataSource={data}
      renderItem={(item) => (
        <List.Item>
          <List.Item.Meta
            avatar={<FileDoneOutlined />}
            title={item.name}
            description={
              <span>{moment(item.createdAt).format("DD/MM/YYYY, hh:mm")}</span>
            }
          />
        </List.Item>
      )}
    />
  );
};
export default FileList;
